<div style="padding: 1rem;">
    <mat-dialog-content>
        <div *ngIf="rawMaterialsOnErrorStatus.length > 0">
            {{ 'label.user.rawmaterial.multiEdit.error.status' | translate }}
            <ul>
                <li *ngFor="let rawMat of rawMaterialsOnErrorStatus" class="nutrient-li">
                    {{ rawMat.code }} - {{ rawMat.label }}
                </li>
            </ul>
        </div>
    
        <div *ngIf="rawMaterialsOnErrorLock.length > 0">
            {{ 'label.user.rawmaterial.multiEdit.error.lock' | translate }}
            <ul>
                <li *ngFor="let rawMat of rawMaterialsOnErrorLock" class="nutrient-li">
                    {{ rawMat.code }} - {{ rawMat.label }}
                </li>
            </ul>
        </div>
    </mat-dialog-content>
    
    <div class="asi-container" fxLayoutAlign="center center">
      <button
        pButton
        class="neq-primeng-button-text"
        (click)="closeDialog(true)"
        label="{{'msg.common.validation.ok' | translate}}"></button>
    <button
        pButton
        class="neq-primeng-button-text"
        (click)="closeDialog(false)"
        label="{{'msg.common.validation.cancel' | translate}}"></button>
    </div>
</div>
